import React from "react";
import { styled } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import IconAvatarStyled from "../IconAvatarStyled";

const LocationOnIconStyled = styled(LocationOnIcon)(({ theme }) => ({
  color: theme.palette.brand.location,
  fontSize: 28,
}));

export const LocationIcon: React.FC = () => (
  <IconAvatarStyled alt="Location Avatar">
    <LocationOnIconStyled />
  </IconAvatarStyled>
);
